<button mat-icon-button class="close-button" mat-dialog-close="false">
    <mat-icon class="close-icon" color="warn">close</mat-icon>
  </button>
  <h2 mat-dialog-title>
    Request for order cancellation - 
    <strong>{{order.OrderNo}}</strong>
    <h5>
        You can also cancel a single item in an order.
    </h5>
  </h2>
  
  <form [formGroup]="cancelOrderForm" #formDirective="ngForm" (submit)="fn_Submit()" autocomplete="off">
    <mat-dialog-content>
      <div class="mat-crd-ui report-bug">
        <mat-form-field>
          <mat-label>Select the products you want to cancel *</mat-label>
          <mat-select formControlName="orderItems" multiple (selectionChange)="fn_ChangeSelectProducts($event)">
            <mat-option [value]="0">All</mat-option>
            <mat-option *ngFor="let item of order.OrderItems" [value]="item.CartItemId">{{item.DesignName}} ({{item.ColorName}}, {{item.SizeName}})</mat-option>
          </mat-select>
          <mat-error *ngIf="f.orderItems.touched && f.orderItems.invalid && f.orderItems.pristine">
            <strong>Select at least one item</strong>
          </mat-error>
          <mat-error *ngIf="!f.orderItems.valid && (f.orderItems.touched && f.orderItems.dirty)">
            <strong>Select at least one item</strong>
          </mat-error>
        </mat-form-field>
  
        <div class="product-lst" *ngIf="fn_ShowCancelProductList()">          
          <h4>Selected products quantity for cancellation</h4>
            <mat-list>
                <mat-list-item *ngFor="let item of orderItemsToCancel">
                    <div mat-line><b>{{ fn_GetProduct(item.CartItemId).DesignName }}</b></div>
                    <div mat-line><small> {{ fn_GetProduct(item.CartItemId).ColorName }}, {{ fn_GetProduct(item.CartItemId).SizeName }} </small></div>

                    <div style="display:inline-flex">
                      <button type="button" (click)="fn_DecrementQty(item)">
                       -
                      </button>
                      <span>&nbsp;{{item.Quantity}}&nbsp;</span>
                      <button type="button"  (click)="fn_IncrementQty(item)">
                       +
                      </button>
                    </div>
                </mat-list-item>
            </mat-list>
        </div>
  
        <mat-form-field>
          <mat-label>Notes </mat-label>
          <textarea matInput formControlName="notes" rows="6" required></textarea>
          <mat-hint>Provide reason for cancellation</mat-hint>
          <mat-error *ngIf="f.notes.touched && f.notes.invalid && f.notes.pristine">
            <strong>Required</strong>
          </mat-error>
          <mat-error *ngIf="!f.notes.valid && (f.notes.touched && f.notes.dirty)">
            <strong>Required</strong>
          </mat-error>
        </mat-form-field>
      </div>
    </mat-dialog-content>
  
    <mat-dialog-actions align="end">
      <button class="no-delete" mat-dialog-close="false">Cancel</button>
      <button type="submit" class="mat-raised-button mat-primary submit-no-delete" [disabled]="cancelOrderForm.invalid" cdkFocusInitial>Submit</button>
    </mat-dialog-actions>
  </form>
